export const ButtonTypeEnum = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INACTIVE: 'inactive',
  INVERSE: 'inverse',
  TRANSPARENT: 'transparent'
} as const

export type ButtonTypeKeys = keyof typeof ButtonTypeEnum
export type ButtonType = (typeof ButtonTypeEnum)[ButtonTypeKeys]

export type ButtonHtmlType = 'submit' | 'button' | 'reset'
